import React, { useState } from "react";
import { get, useFormContext } from "react-hook-form";
import { Alert, Input, IconButton } from "@material-tailwind/react";
import PasswordStrengthMeter from "./passwordStrength";

const RHFPasswordInput = React.forwardRef(function RHFPasswordInput({
    color = "black",
    label = "Password",
    showStrength = false,
    ...props
}, ref) {
    const { register, watch, formState: { errors } } = useFormContext();
    const { ref: rhfRef, ...rest } = register(props.name);
    const error = get(errors, props.name);
    const [showPassword, setShowPassword] = useState(false);
    const value = watch(props.name) || "";

    return (
        <div className="space-y-2">
            <div className="relative w-full">
                <Input
                    {...rest}
                    {...props}
                    type={showPassword ? "text" : "password"}
                    label={label}
                    color={color}
                    inputRef={(el) => {
                        rhfRef(el);
                        if (typeof ref === "function") {
                            ref(el);
                        } else if (ref) {
                            ref.current = el;
                        }
                    }}
                    error={!!error}
                    className="!text-black placeholder:!text-black pr-10"
                    labelProps={{
                        className: "!text-black peer-placeholder-shown:!text-black peer-focus:!text-black",
                    }}
                />
                <IconButton
                    variant="text"
                    size="sm"
                    ripple={false}
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="!absolute right-2 top-2 rounded-full"
                >
                    <span className="material-icons text-gray-600">
                        {showPassword ? "visibility_off" : "visibility"}
                    </span>
                </IconButton>
            </div>
            <PasswordStrengthMeter
                value={value}
                showStrength={showStrength}
            />
            {!!error && (
                <Alert color="red" className="mt-2 rounded-lg py-1 pl-5">
                    {error.message}
                </Alert>
            )}
        </div>
    );
});

export default RHFPasswordInput;